import * as Raven from 'raven-js'
import { ENVIRONMENT, REVISION } from '../config/environment'
import { Store } from '@ngrx/store'
import { AppState } from '../reducers'
import 'rxjs/add/operator/filter'
import { ErrorHandler, Injectable } from '@angular/core'
import { App, ViewController } from 'ionic-angular'

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(
    private store: Store<AppState>,
    private app: App,
  ) {
    Raven
      .config('https://d4c564acaeb34593a02c20fd72ea4d4b@sentry.io/258526', {
        environment: ENVIRONMENT,
        release: REVISION,
        captureUnhandledRejections: false,
      })

    this.store.select((state) => state.user.currentUser)
      .filter(u => !!u) // nullは取り除く
      .subscribe((user) => {
        Raven.setUserContext({ type: user.type, id: user.id.toString() })
      })

    app.viewDidEnter.subscribe((a: ViewController) => {
      const name = a.id
      if (name.match(/^.*Page$/)) { // Page以外は無視する
        const data = {
          name,
          params: a.getNavParams().data
        }

        Raven.captureBreadcrumb({
          level: 'info',
          category: 'pageView',
          message: `Entered to ${name}`,
          data: data,
        })
      }
    })
  }

  handleError(err: any): void {
    console.error(err)

    if(ENVIRONMENT !== 'development') {
      if (err.status !== undefined) {
        // ネットワーク不通と400番台はエラーにしない
        if (!(err.status === 0 || (err.status >= 400 && err.status < 500))) {
          Raven.captureException(JSON.stringify(err))
        }
      } else {
        if (err.originalError) {
          Raven.captureException(err.originalError)
        } else {
          Raven.captureException(JSON.stringify(err))
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app-error-handler.ts